<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="card contactEdition">
            <header class="header-card">
              <p>
                {{ $t('catalogue.newProduct.informations') }}
              </p>
            </header>
            <div class="card-content">
              <information :produit="produit" :materiel="materiel"></information>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="card">
            <header class="header-card">
              <p>
                {{ $t('catalogue.newProduct.restrictionAffichage.title') }}
              </p>
            </header>
            <div class="card-content">
              <restriction :produit="produit.produitEcranNumerique" :typeFace="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-6">
      <div class="card contactEdition">
        <header class="header-card">
          <p>
            {{ $t('catalogue.newProduct.adresse') }}
          </p>
        </header>
        <div class="card-content">
          <div class="column is-12 is-paddingless has-text-default">
            <qd-checkbox v-model="produit.produitEcranNumerique.adressePersonalisee"
              :disabled="!isSynchro" class="mgt-1em">
              {{ $t('catalogue.newProduct.adressePersonalisee') }}
            </qd-checkbox>
          </div>
          <adresse :adresse="produit.produitEcranNumerique.adresse"
            :azimut="produit.produitEcranNumerique.azimut"
            :tableName="PRODUIT"></adresse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adresse from '@/components/catalogue/produitGeneral/m_adresse';
import restriction from '@/components/catalogue/restriction';
import { PRODUIT } from '@/configuration/ville/villeConf';
import information from './m_informations';

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    materiel: {
      type: Object,
      required: false,
    },
  },
  components: {
    adresse,
    information,
    restriction,
  },
  computed: {
    isSynchro() {
      return this.produit.produitEcranNumerique.materielId !== null;
    },
  },
  data() {
    return {
      PRODUIT: PRODUIT,
    };
  },
};
</script>
